import PropTypes from 'prop-types';
import React from 'react';

// Note: Using a local version of new CTA temporarily for now. Should eventually use ch.com lib version
import CTA from '../CTA/CTA';
import CTALayoutStyles from './CTALayout.styled';
import { getCtaProperties } from '@utils/ctaUtils';

// Give the CTAs position numbers based on the number of CTAs so they can be grouped for display.
const groupHomePageCTAs = (ctas) => {
  let grouped = ctas.slice(0, 4); // limit to 4 CTAs max on home page
  switch (grouped.length) {
    case 1:
      grouped[0].ctaPosition = 1;
      break;
    case 2:
      grouped[0].ctaPosition = 1;
      grouped[1].ctaPosition = 1;
      break;
    case 3:
      grouped[0].ctaPosition = 1;
      grouped[1].ctaPosition = 2;
      grouped[2].ctaPosition = 3;
      break;
    case 4:
      grouped[0].ctaPosition = 1;
      grouped[1].ctaPosition = 2;
      grouped[2].ctaPosition = 3;
      grouped[3].ctaPosition = 3;
      break;

    default:
      break;
  }
  return grouped;
};

// We need to ensure parts of the CTA content are not displayed depending on its index and position group number.
// (Note: index value is 0 based, position group is 1 based).
const getHomePageCtaProperties = (cta) => {
  let ctaProps = getCtaProperties(cta);

  // Set this false so the CTA code will evaluate the value for 'target' using getUrlTarget.
  ctaProps.buttonOpensToNewTab = false;

  if (cta?.ctaPosition === 1) {
    // Position group 1 CTAs do not display custom category text (ensure it is disabled).
    ctaProps.customCategory = null;
  } else {
    // ensure CTAs after position group 1 do not display intro text.
    ctaProps.ctaText = null;
  }

  // None of the home page CTAs should display sub-heading or category text.
  ctaProps.subHeadingText = null;
  ctaProps.tag = null;

  return ctaProps;
};

const getCTACards = (ctas, position) => {
  let cards = null;
  if (ctas) {
    cards = ctas
      .filter((cta) => cta?.ctaPosition == position)
      .map((cta, i) => {
        return (
          <CTA
            {...getHomePageCtaProperties(cta, i)}
            key={`${position}-${i}`}
            buttonAutomationId="cta-button-1"
            button2AutomationId="cta-button-2"
            fullWidth={position === 1 ? true : false}
          />
        );
      });
  }

  if (cards.length < 1) {
    cards = null;
  }
  return cards;
};

// This ahndles the layout for the Home Page CTAs.
const CTALayout = ({ ctas }) => {
  const groupedCtas = ctas ? groupHomePageCTAs(ctas) : undefined;

  const cards1 = getCTACards(groupedCtas, 1);
  const cards2 = getCTACards(groupedCtas, 2);
  const cards3 = getCTACards(groupedCtas, 3);

  return (
    <CTALayoutStyles>
      {groupedCtas ? (
        <div className="cta-container">
          {cards1 ? (
            <div className="cta-position-fullwidth">{cards1}</div>
          ) : null}
          {cards2 && cards3 ? (
            <div className="constrained-width">
              <div className="cta-grid-container">
                {cards3.length > 1 ? (
                  <div className="cta-three-container">
                    <div className="cta-div left">{cards2}</div>
                    <div className="cta-div right-a">{cards3[0]}</div>
                    <div className="cta-div right-b">{cards3[1]}</div>
                  </div>
                ) : (
                  <div className="cta-two-container">
                    <div className="cta-div left">{cards2}</div>
                    <div className="cta-div right">{cards3}</div>
                  </div>
                )}
              </div>
            </div>
          ) : null}
        </div>
      ) : null}
    </CTALayoutStyles>
  );
};

CTALayout.propTypes = {
  ctas: PropTypes.any,
};

export default CTALayout;
